/**
 * AttentionDot — the red dot of an entry that waits on the operator. Its size follows the font
 * of the text beside it, so it fits a nav row and a large launcher tile alike. The caller places
 * it, and names what it means in the `aria-description` of the control.
 */

import type { ReactElement } from 'react';

import { cn } from '@/lib/utils';

interface Props {
    className?: string;
}

export const AttentionDot = ({ className }: Props): ReactElement => (
    <span
        aria-hidden="true"
        className={cn('size-[0.4em] shrink-0 rounded-full bg-occ-red-1000', className)}
    />
);
